import React from "react";
import StreakChallengeBannerImg from "../assets/images/scanpoint/streak_challenge_banner.png";
import StickerSteak from "../assets/images/scanpoint/sticker_steak.png";
import { ImageMapArea, ImageMapContainer } from "./ImageMapOverlay";
import {
  computeStreakBannerStampCount,
  getStreakChallengeFromProfile,
  isStreakFiveDayCompleteToday,
  readStoredStreak,
  shouldShowStreakTodayOverlay,
} from "../utils/streakDisplay";

/** Positions of the 5 streak slots on streak_challenge_banner.png (1372×748) */
const STREAK_SLOT_POSITIONS = [
  { left: "6%", top: "40%", width: "17%" },
  { left: "24%", top: "40%", width: "17%" },
  { left: "42%", top: "40%", width: "17%" },
  { left: "59%", top: "40%", width: "17%" },
  { left: "77%", top: "40%", width: "17%" },
];

function StreakChallengeBanner({
  currentStreak = 0,
  showTodayRewardOverlay = false,
  onHowToClick,
  style,
}) {
  const stampCount = Math.min(Math.max(Number(currentStreak) || 0, 0), 5);

  return (
    <ImageMapContainer style={{ marginBottom: 20, ...style }}>
      <img
        src={StreakChallengeBannerImg}
        alt="ภารกิจสะสมคะแนนต่อเนื่อง 5 วัน"
        style={{
          width: "100%",
          height: "auto",
          display: "block",
        }}
      />

      {STREAK_SLOT_POSITIONS.slice(0, stampCount).map((slot, index) => (
        <img
          key={index}
          src={StickerSteak}
          alt={`streak วันที่ ${index + 1}`}
          style={{
            position: "absolute",
            left: slot.left,
            top: slot.top,
            width: slot.width,
            height: "auto",
            pointerEvents: "none",
            zIndex: 3,
            display: "block",
          }}
        />
      ))}

      {showTodayRewardOverlay && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: 16,
            backgroundColor: "rgba(0, 0, 0, 0.55)",
            backdropFilter: "blur(2px)",
            WebkitBackdropFilter: "blur(2px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "8%",
            boxSizing: "border-box",
            zIndex: 8,
            textAlign: "center",
            fontFamily: "'Noto Sans Thai', sans-serif",
            color: "#ffffff",
            pointerEvents: "none",
          }}
        >
          <p
            style={{
              margin: 0,
              fontSize: "clamp(14px, 4vw, 18px)",
              fontWeight: 700,
              lineHeight: 1.45,
            }}
          >
            ได้รับรางวัลของวันนี้เรียบร้อยแล้ว
          </p>
          <p
            style={{
              margin: "10px 0 0",
              fontSize: "clamp(12px, 3.5vw, 15px)",
              fontWeight: 400,
              lineHeight: 1.5,
            }}
          >
            สามารถสแกนเพื่อสะสมแสตมป์ได้อีกครั้งในวันพรุ่งนี้
          </p>
        </div>
      )}

      <ImageMapArea
        ariaLabel="วิธีการเล่น"
        title="วิธีการเล่น"
        bottom="5%"
        left="38%"
        width="24%"
        height="14%"
        onClick={onHowToClick}
        style={{ zIndex: showTodayRewardOverlay ? 3 : 10 }}
      />
    </ImageMapContainer>
  );
}

export default StreakChallengeBanner;

export function resolveRawCurrentStreak(profile) {
  const streakChallenge = getStreakChallengeFromProfile(profile);
  return readStoredStreak(streakChallenge);
}

export function resolveCurrentStreak(profile) {
  const streakChallenge = getStreakChallengeFromProfile(profile);
  if (streakChallenge) {
    return readStoredStreak(streakChallenge);
  }

  if (profile?.streakStampCount != null) {
    return Number(profile.streakStampCount);
  }

  return 0;
}

export function resolveStreakTodayQualified(profile) {
  const streakChallenge = getStreakChallengeFromProfile(profile);
  return Boolean(streakChallenge?.todayQualified);
}

/** ครบ 5 วันแล้ว reset streak — แสดง overlay บน card ได้ */
export function resolveStreakFiveDayCompleteToday(profile) {
  return isStreakFiveDayCompleteToday(getStreakChallengeFromProfile(profile));
}

/** จำนวน stamp บน banner — ครบ 5 วันวันนี้ยังแสดง 5 ดวงจนกว่าจะขึ้นวันใหม่ */
export function resolveStreakBannerStampCount(profile) {
  return computeStreakBannerStampCount(getStreakChallengeFromProfile(profile));
}

export function resolveStreakShowTodayRewardOverlay(profile) {
  return shouldShowStreakTodayOverlay(getStreakChallengeFromProfile(profile));
}

export function resolveStreakFromScanResult(scanResult) {
  if (!scanResult?.streak?.length) {
    return null;
  }

  const values = scanResult.streak
    .map((item) => Number(item?.currentStreak))
    .filter((value) => Number.isFinite(value));

  return values.length ? Math.max(...values) : null;
}
